'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    border-radius: ', ';\n    padding: .5em;\n    margin: 1em 0;\n    background: ', ';\n    border: ', ';\n\n'], ['\n    border-radius: ', ';\n    padding: .5em;\n    margin: 1em 0;\n    background: ', ';\n    border: ', ';\n\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

var _framerMotion = require('framer-motion');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Group = exports.Group = (0, _styledComponents2.default)(_framerMotion.motion.div)(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type;
  return type ? theme.stateColors[type] : theme.middleground;
}, function (_ref3) {
  var theme = _ref3.theme,
      type = _ref3.type;
  return '.1rem solid ' + (type ? (0, _chromaJs2.default)(theme.stateColors[type]).brighten(0.3) : (0, _chromaJs2.default)(theme.middleground).brighten(0.4));
});